export const getSharableSurveyText = (link: string) => {
    return `Olá!\nEste formulário faz parte do acompanhamento psicológico em andamento.\nAs perguntas ajudam a reunir informações importantes para a avaliação.\nAs respostas são confidenciais e utilizadas apenas para fins profissionais.\nAcesse o formulário pelo link abaixo:\n${link}`;
};
